import React from "react";
import "./LoadingSpinnerSmall.scss";

const LoadingSpinnerSmall = () => {
  return (
    <div className="lds-facebook">
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default LoadingSpinnerSmall;
